import { createContext } from 'react';
import { StateContextType } from '../../types';
const iUserContextState = {
    state: {
        page: -1,
        portalId: 0,
        appId: '',
        processor: null,
        appCode: ''
    },
    setState: null,
    update_resentInvitation: new Date().getTime()
}

const StateContext = createContext<StateContextType>(iUserContextState);

export default StateContext;